import React from 'react';
import BeerInfo from './BeerInfo';
import { beersInfo } from '../../utils/constants';

export default function BeerCard({ type }) {
  return (
    <div className='relative z-20 flex flex-col md:flex-row w-full shadow-lg overflow-hidden transition-all duration-500 ease-in-out h-auto'>
      {/* Info Section */}
      <div
        id='info'
        className='flex items-center justify-center w-full md:w-1/2 p-6 md:p-10 bg-gradient-to-b from-[#242423] to-[#000000]'
      >
        <div className='p-4 md:p-8 h-full flex items-center'>
          <BeerInfo beer={beersInfo.find((beer) => beer.name === type)} />
        </div>
      </div>

      {/* Cover Image Section */}
      <div
        id='cover-image'
        className='w-full md:w-1/2 flex items-center justify-center transition-all duration-500 ease-in-out'
      >
        <div className='overflow-hidden h-full w-full flex items-center'>
          <img
            src={`/images/${type}_small.jpeg`}
            alt='logo'
            className='w-full h-full object-cover'
          />
        </div>
      </div>

      {/* Bottle Image (Hidden on Small Screens) */}
      {type === 'djeneral' && (
        <img
          id='bottle-image'
          src='/images/flasica2.png'
          alt='beer'
          className='hidden md:block absolute inset-1/2 h-[115%] -translate-x-1/2 -translate-y-1/2 z-50 rotate-[-1deg] pointer-events-none'
        />
      )}
      {type === 'tango' && (
        <img
          id='bottle-image'
          src='/images/tango-flasica.png'
          alt='beer'
          className='hidden md:block absolute inset-1/2 h-[100%] -translate-x-1/2 -translate-y-1/2 z-50  pointer-events-none'
        />
      )}
    </div>
  );
}
